// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3YUzi{background-color:#fff;border-radius:.25rem;color:#595757;margin-bottom:1rem}._3YUzi+._3YUzi{margin-top:1.5rem}._3Ftcj+._3Ftcj{margin-top:0;margin-bottom:1.5rem}._3J0m6{overflow-y:scroll}._3QpAg{max-height:212px;max-height:13.25rem}._3ySct{max-height:400px;max-height:25rem}.WQ4SQ{padding:.75rem 1rem;border-bottom:1px solid #dcdddd;font-size:16px;font-size:1rem;font-weight:500;line-height:20px;line-height:1.25rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}._3xPO6{display:none}@media(max-width:1023px){._3xPO6{display:block;margin-bottom:1rem}}@media(max-width:1023px){._9GdfP{display:none}}._26E3G{display:-ms-flexbox;display:flex;-ms-flex-direction:column-reverse;flex-direction:column-reverse}._2l1F4{position:fixed;top:0;left:0;width:100%;height:100vh;background-color:#f7f8f8;z-index:var(--zIndex-modal);overflow-y:auto}@media(max-width:767px){._2l1F4{padding-left:0;padding-right:0;background-color:#fff}}._2l1F4 ._3QpAg,._2l1F4 ._3ySct{max-height:none}._2l1F4 ._3YUzi{border-bottom:1px solid #dcdddd}._2l1F4 ._3YUzi+._3YUzi{margin-top:0}._1D_Ru{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;background-color:#fff;border-bottom:1px solid #dcdddd;position:sticky;top:0;z-index:2;padding:1rem 1.5rem}._1s-KP{margin-left:auto}._3A5mT{margin-top:1.5rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"group": "_3YUzi",
	"groupReversed": "_3Ftcj",
	"list": "_3J0m6",
	"free": "_3QpAg",
	"paid": "_3ySct",
	"groupTitle": "WQ4SQ",
	"toggler": "_3xPO6",
	"wrapper": "_9GdfP",
	"listReversed": "_26E3G",
	"modalWrapper": "_2l1F4",
	"modalHeader": "_1D_Ru",
	"modalCloseIcon": "_1s-KP",
	"syllabuses": "_3A5mT"
};
module.exports = exports;
